import { PanelLeftClose, PanelLeftOpen } from "lucide-react";
import { Button } from "../ui/button/index.js";
import { SimpleTooltip } from "../ui/tooltip/index.js";
import { cn } from "../../lib/utils.js";

export function WorkspaceInternalSidebarHeader({
  title,
  collapsed,
  onCollapsedChange,
  expandLabel,
  collapseLabel,
  collapseTestId,
}: {
  title: string;
  collapsed: boolean;
  onCollapsedChange?: (collapsed: boolean) => void;
  expandLabel: string;
  collapseLabel: string;
  collapseTestId: string;
}): React.JSX.Element {
  const collapseButton = onCollapsedChange ? (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      className="size-8 shrink-0 p-0 text-muted hover:text-foreground"
      onClick={() => onCollapsedChange(!collapsed)}
      aria-label={collapsed ? expandLabel : collapseLabel}
      aria-expanded={!collapsed}
      data-testid={collapseTestId}
    >
      {collapsed ? (
        <PanelLeftOpen size={16} className="rtl:-scale-x-100" aria-hidden="true" />
      ) : (
        <PanelLeftClose size={16} className="rtl:-scale-x-100" aria-hidden="true" />
      )}
    </Button>
  ) : null;

  return (
    <div
      className={cn(
        "flex shrink-0 items-center gap-1 border-b border-border/60 px-2 py-2",
        collapsed ? "justify-center" : "justify-between",
      )}
    >
      {!collapsed ? (
        <p className="m-0 truncate px-1 text-[0.8125rem] font-semibold leading-5 tracking-[-0.01em] text-foreground">
          {title}
        </p>
      ) : null}
      {collapsed && collapseButton ? (
        <SimpleTooltip content={expandLabel}>
          <div>{collapseButton}</div>
        </SimpleTooltip>
      ) : (
        collapseButton
      )}
    </div>
  );
}
